import React, { useEffect, useState, useRef } from "react";
import useClickOutside from "../../hook/UseClickOutSide";

export interface OptionsType {
  id: number;
  value: string;
}
interface PropsType {
  onSelect: (value: OptionsType) => void;
  options: OptionsType[];
  defaultValue?: OptionsType;
  hasAll?: boolean;
  isReset?: boolean;
  selecteValue?: OptionsType;
  isDisable?: boolean;
}

function SelectItems({
  onSelect,
  options,
  defaultValue,
  hasAll,
  selecteValue,
  isDisable = false,
}: PropsType) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState<OptionsType>();
  const [option, setOption] = useState<OptionsType[]>([]);
  const dropdownRef = useRef(null);

  const handleClickOpenItems = (value: boolean) => {
    if (!isDisable) {
      setIsOpen(value);
    }
  };

  const handleClickItems = (items: OptionsType) => {
    setSelectedValue(items);
    onSelect(items);
    setIsOpen(false);
  };

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
      onSelect(defaultValue);
    }
    if (selecteValue) {
      setSelectedValue(selecteValue);
    } else {
      if (hasAll) {
        let rawData = option.filter((e) => e.id === 0);
        setSelectedValue(rawData[0]);
        onSelect(rawData[0]);
      } else {
        setSelectedValue(option[0]);
        onSelect(option[0]);
      }
    }
  }, [option]);

  useEffect(() => {
    let rawData = [...options];
    if (hasAll) {
      rawData.push({ id: 0, value: "ทั้งหมด" });
    }
    setOption(rawData);
  }, []);

  useClickOutside(dropdownRef, () => {
    setIsOpen(false);
  });

  useEffect(() => {
    if (selecteValue) {
      setSelectedValue(selecteValue);
    } else {
      setSelectedValue(option[0]);
    }
  }, [selecteValue]);

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className={`flex self-stretch pl-4 pr-2 h-10 bg-primary-contrast items-center rounded-xl border-[1px] ${
          isDisable ? "border-gray-1" : "border-gray-2"
        }`}
        onClick={() => handleClickOpenItems(!isOpen)}
      >
        <p
          className={`w-full text-sm ${
            isDisable ? "text-text-disabled" : "text-text-primary"
          } font-light`}
        >
          {selectedValue?.value}
        </p>
        <div className={`${isOpen && "-rotate-180"}`}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_904_68250)">
              <path
                d="M6.70978 9.30996C7.09978 8.91996 7.72978 8.91996 8.11978 9.30996L11.9998 13.19L15.8798 9.30996C16.2698 8.91996 16.8998 8.91996 17.2898 9.30996C17.6798 9.69996 17.6798 10.33 17.2898 10.72L12.6998 15.31C12.3098 15.7 11.6798 15.7 11.2898 15.31L6.69978 10.72C6.31978 10.34 6.31978 9.69996 6.70978 9.30996Z"
                fill={`${isDisable ? "#F6F6F6" : "#8E8E8E"}`}
              />
            </g>
            <defs>
              <clipPath id="clip0_904_68250">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="matrix(0 1 1 0 0 0)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      {isOpen && !isDisable && (
        <div className="w-full z-10 absolute bg-primary-contrast p-2 border-[1px] mt-1 border-gray-2 rounded-2xl">
          {option.map((e) => (
            <div
              key={e?.id}
              onClick={() => handleClickItems(e)}
              className="w-full py-1 pl-4 pr-2 cursor-pointer hover:bg-primary-light rounded-xl"
            >
              <p className="text-sm text-text-primary font-light">{e.value}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SelectItems;
